// extracted by mini-css-extract-plugin
export default {"card":"Course_card__e3yqo","cardImgWrapper":"Course_cardImgWrapper__chwMC","cardBody":"Course_cardBody__9PORd","bodyOne":"Course_bodyOne__Se5JK","bodyTwo":"Course_bodyTwo__YUpGD"};